module.exports = "table {\n  width: 100%; }\n  table tr.data-row {\n    border: 1px solid #DDDDDD; }\n  table tr.data-row:hover, table tr.data-row.active {\n      background: #E6E6E6;\n      cursor: pointer; }\n  table tr.data-row td {\n      border: 1px solid #DDDDDD;\n      padding: 4px; }\n  table th {\n    border: 1px solid #DDDDDD;\n    padding: 10px 4px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/expandable-table/expandable-table.component.scss
// module id = ./src/app/shared/components/expandable-table/expandable-table.component.scss
// module chunks = main